import React, { useState } from "react";
import { apiRequest } from "../apiService/allapi";
import { successAlert, errorAlert } from "../apiService/sweetAlert";
import { isLoggedIn, updateGuestCartQty, dispatchCartUpdate } from "../helper/cartUtils";

const QuantityControl = ({
  initialQuantity = 1,
  itemId,
  maxStock = Infinity, // New prop for stock limit
  refreshCart,
  updateQty,
}) => {
  const [quantity, setQuantity] = useState(initialQuantity);

  const incrementQuantity = async () => {
    const newQty = Math.min(quantity + 1, maxStock);
    if (newQty === quantity) return; // Already at max

    try {
      setQuantity(newQty);

      if (isLoggedIn()) {
        const token = localStorage.getItem("token");
        const res = await apiRequest(
          "/Cart/add-to-cart",
          "POST",
          { pid: itemId, qty: 1 },
          { Authorization: `Bearer ${token}` },
        );
        if (res?.data?.status !== true) {
          setQuantity(quantity); // Revert on failure
          if (res?.data?.message?.toLowerCase().includes('stock') || res?.data?.message?.toLowerCase().includes('insufficient')) {
            errorAlert(res.data.message || "Insufficient stock");
          }
          refreshCart?.();
          return;
        }
        dispatchCartUpdate();
      } else {
        // Guest cart - use optimistic with stock check
        updateGuestCartQty(itemId, newQty);
        dispatchCartUpdate();
      }
      updateQty?.(itemId, newQty);
      refreshCart?.();
    } catch (error) {
      setQuantity(quantity); // Revert
      errorAlert("Failed to update quantity");
      refreshCart?.();
    }
  };

  const decrementQuantity = async () => {
    if (quantity > 1) {
      const newQty = quantity - 1;
      try {
        setQuantity(newQty);

        if (isLoggedIn()) {
          const token = localStorage.getItem("token");
          const res = await apiRequest(
            "/Cart/removeCart",
            "POST",
            { pid: itemId, qty: 1 },
            { Authorization: `Bearer ${token}` },
          );
          if (res?.data?.status !== true) {
            setQuantity(quantity); // Revert
          }
          dispatchCartUpdate();
        } else {
          updateGuestCartQty(itemId, newQty);
          dispatchCartUpdate();
        }
        updateQty?.(itemId, newQty);
        refreshCart?.();
      } catch (error) {
        setQuantity(quantity); // Revert
        refreshCart?.();
      }
    }
  };

  return (
    <div className="d-flex rounded-4 overflow-hidden">
      <button
        type="button"
        onClick={decrementQuantity}
        className="quantity__minus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
      >
        <i className="ph ph-minus" />
      </button>

      <input
        type="number"
        className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-4"
        value={quantity}
        min={1}
        readOnly
      />

      <button
        type="button"
        onClick={incrementQuantity}
        className="quantity__plus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
      >
        <i className="ph ph-plus" />
      </button>
    </div>
  );
};

export default QuantityControl;

